import {
  Center,
  Flex,
  FlexProps,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  VStack,
} from '@chakra-ui/react'
import React from 'react'
import { useSelector } from 'react-redux'

import { useTranslations } from '~shared-components/hooks/useTranslations'
import { IconTrack } from '~shared-components/icons/brand/IconTrack'

import { NavigationSelector } from '../../redux/selectors/navigation.selector'
import { TranslationKey } from '../../translations/default'
import { NavigationBlockModalType } from '../../utils/enums'
import { LeadText } from '..'
import { GenericModalFooter } from './GenericModalFooter'
import { ModalCloseButton } from './ModalCloseButton'

const IconWrapper: React.FC<FlexProps> = ({ children }) => (
  <Flex
    alignItems="center"
    border="2px solid"
    borderColor="red.80"
    borderRadius="50%"
    display="inline-flex"
    h={20}
    justifyContent="center"
    mb={10}
    mt={4}
    w={20}
  >
    {children}
  </Flex>
)

export const NavigationModal = () => {
  const t = useTranslations()
  const isOpen = !useSelector(NavigationSelector.isAllowedToLeave)
  const navType = useSelector(NavigationSelector.navType)
  const onCancel = useSelector(NavigationSelector.onCancel)
  const onConfirm = useSelector(NavigationSelector.onConfirm)

  return (
    <Modal
      isCentered
      isOpen={isOpen}
      motionPreset="scale"
      onClose={onCancel}
      size="xl"
    >
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton aria-label="close" onClose={onCancel} />
        <ModalBody>
          <VStack alignItems="flex-start" spacing={5} w="100%">
            <Center w="100%">
              <IconWrapper>
                <IconTrack color="red.80" height={9} name="switch" width={9} />
              </IconWrapper>
            </Center>
            <LeadText bold>{t(navType?.message as TranslationKey)}</LeadText>
            {navType?.type === NavigationBlockModalType.UserEdit && (
              <LeadText>{t('userEdit.cancel.confirm')}</LeadText>
            )}
            {navType?.type === NavigationBlockModalType.OrderEdit && (
              <LeadText>{t('logout.confirmlogout')}</LeadText>
            )}
          </VStack>
        </ModalBody>
        <ModalFooter>
          <GenericModalFooter
            actionButtonId="modal-navigate-btn"
            actionIcon="IconCheckmark"
            actionTextLabel="label.yes"
            cancelTextLabel="label.no"
            onAction={onConfirm}
            onCancel={onCancel}
          />
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
